(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.header = this.closest('.section-header') || this.closest('.shopify-section');
      if (!this.header) return;
      this.controller = new AbortController();
      this.always = ['always', 'reduce-logo-size'].includes(this.dataset.stickyType);
      this.currentScrollTop = Math.max(0, window.scrollY);
      this.preventReveal = false;
      this.boundary = this.header.getBoundingClientRect().bottom + window.scrollY;
      this.setHeaderHeight = () => document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.setHeaderHeight();
      if (this.always) this.header.classList.add('shopify-section-header-sticky');
      this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.resizeObserver.observe(this.header);
      const options = { signal: this.controller.signal };
      this.addEventListener('preventHeaderReveal', () => { this.preventReveal = true; }, options);
      this.addEventListener('focusin', () => this.reveal(), options);
      window.addEventListener('resize', () => {
        this.setHeaderHeight();
        this.boundary = this.header.offsetHeight;
      }, options);
      window.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.onScroll(); });
      }, { ...options, passive: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.revealTimer);
    }
    onScroll() {
      const top = Math.max(0, window.scrollY || document.documentElement.scrollTop);
      const past = top > this.boundary;
      this.header.classList.toggle('scrolled-past-header', past);
      if (this.always) { this.currentScrollTop = top; return; }
      const predictive = this.querySelector('predictive-search');
      const interacting = this.contains(document.activeElement) || this.querySelector('header-drawer details[open], details-modal details[open]') || predictive?.isOpen;
      if (interacting) { this.reveal(); this.currentScrollTop = top; return; }
      if (!past) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      } else if (top > this.currentScrollTop && !this.preventHide) {
        this.hide();
      } else if (top < this.currentScrollTop) {
        if (!this.preventReveal) this.reveal();
        else {
          clearTimeout(this.revealTimer);
          this.revealTimer = setTimeout(() => { this.preventReveal = false; }, 66);
        }
      }
      this.currentScrollTop = top;
    }
    hide() {
      if (this.always) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.querySelectorAll('header-menu').forEach(menu => {
        if (typeof menu.close === 'function') menu.close();
      });
      const modal = this.querySelector('details-modal');
      if (typeof modal?.close === 'function') modal.close(false);
    }
    reveal() {
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.always || window.scrollY > this.boundary) this.header.classList.add('shopify-section-header-sticky', 'animate');
    }
  });
}
if (!customElements.get('herzecards-header-tools')) {
  customElements.define('herzecards-header-tools', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.root = this.closest('.shopify-section');
      if (!this.root) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      this.timers = new Map();
      this.menus = Array.from(this.root.querySelectorAll('.header__inline-menu header-menu'));
      this.close = menu => {
        const details = menu.querySelector('details');
        if (!details) return;
        if (typeof menu.close === 'function') menu.close();
        else { details.open = false; details.querySelector('summary')?.setAttribute('aria-expanded', 'false'); }
      };
      this.menus.forEach(menu => {
        const details = menu.querySelector('details');
        const summary = details?.querySelector('summary');
        if (!details || !summary) return;
        menu.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || this.dataset.hover !== 'true' || !this.hoverMedia.matches) return;
          clearTimeout(this.timers.get(menu));
          this.menus.forEach(other => { if (other !== menu && !other.contains(document.activeElement)) this.close(other); });
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        }, options);
        menu.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse' || this.dataset.hover !== 'true' || !this.hoverMedia.matches) return;
          clearTimeout(this.timers.get(menu));
          this.timers.set(menu, setTimeout(() => { if (!menu.contains(document.activeElement)) this.close(menu); }, 180));
        }, options);
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            clearTimeout(this.timers.get(menu));
            this.close(menu);
            summary.focus();
          }
        }, options);
      });
      document.addEventListener('pointerdown', event => {
        if (!this.root.contains(event.target)) this.menus.forEach(menu => this.close(menu));
      }, options);
      this.hoverMedia.addEventListener('change', () => {
        this.timers.forEach(timer => clearTimeout(timer));
        this.menus.forEach(menu => this.close(menu));
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.timers?.forEach(timer => clearTimeout(timer));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
